module.exports = __webpack_public_path__ + "static/img/footer.056f3ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer.jpg
// module id = RfGf
// module chunks = 1